export default __webpack_public_path__ + "static/media/Baker2.9b6ca49f.JPG";